import { useTranslation } from 'react-i18next';
import BasePageComponent from '../../components/BasePageComponent';
import './Support.css';

const Support = (): JSX.Element => {
  const { t } = useTranslation();

  const services = [
    {
      key: 'salon_real_estate',
      details: t('support.services.salon_real_estate.details'),
      features: {
        location: t('support.services.salon_real_estate.features.location'),
        size: t('support.services.salon_real_estate.features.size'),
        facilities: t('support.services.salon_real_estate.features.facilities'),
        price: t('support.services.salon_real_estate.features.price'),
      },
    },
    {
      key: 'tech_support',
      details: t('support.services.tech_support.details'),
      features: {
        website: t('support.services.tech_support.features.website'),
        reservation: t('support.services.tech_support.features.reservation'),
        pos: t('support.services.tech_support.features.pos'),
        custom: t('support.services.tech_support.features.custom'),
      },
    },
    {
      key: 'matterport',
      details: t('support.services.matterport.details'),
      features: {
        scanning: t('support.services.matterport.features.scanning'),
        virtual: t('support.services.matterport.features.virtual'),
        marketing: t('support.services.matterport.features.marketing'),
        experience: t('support.services.matterport.features.experience'),
      },
    },
  ];

  return (
    <BasePageComponent
      id="support"
      title={t('support.title')}
      description={t('support.description')}
    >
      <div className="services-card-container">
        {services.map((service) => (
          <div key={service.key} className="service-card">
            <h2>{t(`support.services.${service.key}.title`)}</h2>
            <p className="service-description">
              {t(`support.services.${service.key}.details`)}
            </p>
            <div className="features-list">
              {Object.entries(service.features).map(([key, value]) => (
                <div key={key} className="feature-item">
                  {value}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </BasePageComponent>
  );
};

export default Support; 